var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.413 6.193 8 8.78l2.587-2.587a.664.664 0 1 1 .94.94l-3.06 3.06c-.26.26-.68.26-.94 0l-3.06-3.06a.664.664 0 0 1 0-.94.678.678 0 0 1 .946 0z",
    fill: "currentColor"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUuNDEzIDYuMTkzIDggOC43OGwyLjU4Ny0yLjU4N2EuNjY0LjY2NCAwIDEgMSAuOTQuOTRsLTMuMDYgMy4wNmMtLjI2LjI2LS42OC4yNi0uOTQgMGwtMy4wNi0zLjA2YS42NjQuNjY0IDAgMCAxIDAtLjk0LjY3OC42NzggMCAwIDEgLjk0NiAweiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";